import React from 'react';


import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline, StyledEngineProvider } from '@material-ui/core';
import {
    darkTheme,
    RainbowKitProvider
} from "@rainbow-me/rainbowkit";
import { chains } from './hooks/wagmi';


// routing
import Routes from './routes';

// defaultTheme
import theme from './themes';

// project imports
import NavigationScroll from './layout/NavigationScroll';
import { AuthContextProvider } from './contexts/auth-context';


//-----------------------|| APP ||-----------------------//

const App = () => {

    return (
        <StyledEngineProvider injectFirst>
            <AuthContextProvider>
                <RainbowKitProvider
                    appInfo={{
                        appName: 'contakt-KYC'
                    }}
                    chains={chains}
                    theme={darkTheme({
                        accentColor: '#7b3fe4',
                        accentColorForeground: 'white',
                        borderRadius: 'small',
                        fontStack: 'system',
                        overlayBlur: 'small',
                      })}
                    >
                    <ThemeProvider theme={theme()}>
                        <CssBaseline />
                        <NavigationScroll>
                            <Routes />
                        </NavigationScroll>
                    </ThemeProvider>
                </RainbowKitProvider>
            </AuthContextProvider>
        </StyledEngineProvider>
    );
};

export default App;
